import React from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa';
import { FontWeight } from '../theme/Theme';
import { getShiftRatingValue } from '../util/shiftRating';
import { IndustryMode, RoleName, ShiftLike } from '../util/shiftRating';

const STAR_COLOR = '#ffb400';

const renderRatingStars = (ratingValue: number) => {
  const roundedRating = Math.max(0, Math.min(5, Math.round(ratingValue)));
  return Array.from({ length: 5 }, (_, index) => {
    const style: React.CSSProperties = {
      marginLeft: index === 0 ? 6 : 2,
      verticalAlign: 'middle',
    };
    return index < roundedRating ? (
      <FaStar
        key={`shift-rating-star-${index}`}
        size={12}
        color={STAR_COLOR}
        style={style}
      />
    ) : (
      <FaRegStar
        key={`shift-rating-star-${index}`}
        size={12}
        color={STAR_COLOR}
        style={style}
      />
    );
  });
};

export interface ShiftRatedRowProps {
  shift: ShiftLike | null | undefined;
  industryMode: IndustryMode | null | undefined;
  roleName: RoleName | null | undefined;
}

const ShiftRatedRow: React.FC<ShiftRatedRowProps> = ({
  shift,
  industryMode,
  roleName,
}) => {
  const ratingValue = getShiftRatingValue(shift, industryMode, roleName);

  if (ratingValue == null || !Number.isFinite(ratingValue)) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 2,
      }}
    >
      <span
        style={{
          fontWeight: FontWeight.bold as React.CSSProperties['fontWeight'],
        }}
      >
        Shift Rated:
      </span>
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {renderRatingStars(ratingValue)}
      </span>
    </div>
  );
};

export default ShiftRatedRow;
